import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cog } from 'lucide-react';
import { jobs } from '../lib/jobs';

const ACTIVE = ['queued', 'processing'];

export function useJob() {
  const [s, setS] = useState(jobs.get());
  useEffect(() => jobs.subscribe(setS), []);
  return s;
}

export const isActive = (job) => !!job && ACTIVE.includes(job.status);

/** Compact global progress pill; tapping it goes back to the Studio on the game being generated. */
export default function JobBadge({ onOpen, hidden = false }) {
  const { job, meta } = useJob();
  const nav = useNavigate();
  if (hidden || !isActive(job)) return null;
  const pct = Math.max(0, Math.min(100, job.progress_percent || 0));
  const open = () => {
    if (meta?.gameId) sessionStorage.setItem('nexora.openGame', meta.gameId);
    if (onOpen) onOpen(meta?.gameId); else nav('/dev');
  };
  return (
    <button data-testid="job-badge" onClick={open} title={job.current_phase || 'In elaborazione'} aria-label={`Generazione in corso ${pct}%: torna allo Studio`}
      className="fixed left-1/2 -translate-x-1/2 top-[calc(env(safe-area-inset-top)+8px)] z-[90] flex items-center gap-2 rounded-full border border-cyan-400/50 bg-black/75 backdrop-blur-xl px-3.5 py-1.5 text-[11px] font-bold text-cyan-100 shadow-[0_0_24px_rgba(34,211,238,.35)] hover:border-cyan-300 transition-colors">
      <Cog className="h-3.5 w-3.5 animate-spin [animation-duration:2.5s]" />
      <span>In elaborazione: <span data-testid="job-badge-percent">{pct}%</span></span>
      <span className="hidden sm:block h-1 w-16 rounded-full bg-white/10 overflow-hidden"><span className="block h-full bg-gradient-to-r from-violet-500 to-cyan-400 transition-[width] duration-500" style={{ width: `${pct}%` }} /></span>
    </button>
  );
}
